import(/* webpackMode: "eager" */ "/codebuild/output/src4238973859/src/medh-web/src/app/error.tsx");
